import Auth from '@aws-amplify/auth';

// Use Cognito's existing self-service recovery operation. Never pick a delivery
// address from an editable profile, change verified attributes, or sign out the
// operator. Cognito chooses the eligible channel using the pool's configuration.
export async function requestPasswordRecoveryCode(username, language) {
  if (!username) throw new Error('RECOVERY_UNAVAILABLE');
  const code = typeof language === 'string' ? language.toLowerCase().split(/[-_]/)[0] : '';
  const metadata = ['en', 'ms', 'id', 'vi'].includes(code) ? { recoveryLanguage: code } : null;
  const result = metadata
    ? await Auth.forgotPassword(username, metadata) : await Auth.forgotPassword(username);
  const details = result && result.CodeDeliveryDetails;
  if (!details || !['EMAIL', 'SMS'].includes(details.DeliveryMedium) || !details.Destination) {
    return { accepted: true, medium: null, destination: null };
  }
  return {
    accepted: true,
    medium: details.DeliveryMedium,
    destination: details.Destination,
  };
}

// Passwords entered by an administrator are always temporary. Enforce this at
// payload construction too, so stale checkbox state cannot request permanence.
export function temporaryPasswordPayload(staff) {
  if (!staff.user || !staff.user.updatePassword) return staff;
  return { ...staff, user: { ...staff.user, passwordUpdateRequired: true } };
}

// The handoff always targets the configured Secure origin, without profile or
// query data. Do not turn an invalid configuration into a relative link.
export function passwordRecoveryURL(base) {
  if (!base) return undefined;
  try {
    const url = new URL(base);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return undefined;
    return `${url.origin}/forgot-password`;
  } catch (_) { return undefined; }
}



// WEBPACK FOOTER //
// ./src/actions/passwordRecovery.js